/* Auto-generated from builtin-lambda-schemas.proto */
import { IWorkflowLocation, MessageType } from './message-schema';
import { IType } from './type-schema';
export interface IExpression {
    type?: string;
}
export interface IEdgeLambdaConfig {
    edgeId?: number;
    messageType?: MessageType;
    condition?: IInlineLambdaConfig;
}
export interface IExpressionLambdaConfig {
    expression?: string;
}
export interface IJoinExpression {
    expression?: string;
}
export interface IEdgeAction {
    edge?: number;
    action?: IJoinExpression;
}
export interface IJoinConditionalBlock {
    condition?: IJoinExpression;
    initialize?: IJoinExpression;
    actionExpression?: IJoinExpression;
    edgeActions?: IEdgeAction[];
    finalize?: IJoinExpression;
    inlineCondition?: IInlineLambdaConfig;
}
export interface IEdgeSchema {
    edge?: number;
    schema?: IType;
}
export interface IJoinConfig {
    inputEdgeIds?: number[];
    joinEdgeId?: number;
    timeout?: number;
    initialize?: IJoinExpression;
    conditionals?: IJoinConditionalBlock[];
    finalize?: IJoinExpression;
    coalesceExpiry?: boolean;
}
export interface IMessageOutputLambdaConfig {
    outputTopic?: string;
    outputLambdaType?: string;
}
export enum WaitOnStrategy {
    All = 0,
    Any = 1
}
export interface IWaitOnLambdaConfig {
    inputEdgeIds?: number[];
    waitOnEdgeId?: number;
    strategy?: WaitOnStrategy;
    timeout?: number;
}
export interface IEnterWorkflowConfig {
    workflowId?: number;
    highLevelWorkflowId?: string;
}
export interface IExitWorkflowConfig {
    inputEdges?: IWorkflowLocation[];
    innerHighLevelWorkflowId?: string;
    outerHighLevelWorkflowId?: string;
}
export interface IInlineLambdaConfig {
    name?: string;
    lambda?: string;
    operatesOnMessage?: boolean;
    globals?: { [k: string]: string };
    debuggable?: boolean;
    executeOnException?: boolean;
}
export interface IJoinStatus {
    timedOut?: boolean;
    payloadCount?: number;
    edgesReceived?: number[];
    edgesToJoin?: number[];
}
